import { PopinProps } from '../../components/Popin'
import ActionButton, { ActionButtonProps } from '../../components/ActionButton'
import tcPopin from '../tcPopin/tcPopin'

export const planningNewObjectivesModalTransformer = (
  t?: any,
  isOpen?: boolean,
  handleClose?: () => void,
  buttons?: ActionButtonProps[],
  improvedObjectivesList?: any,
  newObjectiveIndex?: number
): PopinProps => ({
  title: t('planning_newobjectives_modal_title'),
  textsContent: (
    <p
      className="bold"
      dangerouslySetInnerHTML={{
        __html: t('planning_newobjectives_modal_description'),
      }}
    />
  ),
  buttonsContent: (
    <div className="mobile-reverse">
      {buttons &&
        buttons.map((button) => <ActionButton key={button.text} {...button} />)}
    </div>
  ),
  isOpen,
  handleClose,
  linkProps: {
    onClickHandler: () => {
      tcPopin({
        popin_name: `popin maj objectifs_${t(
          'planning_newobjectives_modal_later_cta'
        )}_mb`,
      })
      handleClose?.()
    },
    text: t('planning_newobjectives_modal_later_cta') ?? '',
  },
  objectivesCardProps: {
    currentIndex: newObjectiveIndex,
    cards: improvedObjectivesList,
  },
  buttonsContentInRow: true,
})
